import { ISbComponentType, ISbStoryData } from 'storyblok-js-client';

import { getStories } from './getStories';

import { GetStoriesParams } from './types';

export const getRelationStory = async <T = ISbComponentType<string>>(
  relationOrUuid: ISbStoryData<T> | string | undefined,
  params?: GetStoriesParams
) => {
  if (!relationOrUuid) {
    return null;
  }

  if (typeof relationOrUuid !== 'string') return relationOrUuid;

  const {
    data: { stories },
  } = await getStories<T>(
    {
      ...params,
      by_uuids: relationOrUuid,
    },
    {
      next: {
        revalidate: 86_400, // 24h
        tags: [`relation-story-${relationOrUuid}`],
      },
    }
  );

  return stories[0];
};
